/* SPC/LST-only Gorgias appearance adjustments; the Bootcap channel is untouched. */
(function () {
  // Keep the launcher clear of Klaviyo's 10% teaser only while that teaser exists.
  // Gorgias's 45px channel offset remains the fallback if this stylesheet cannot load.
  var launcherPositionStyle = document.createElement('style');
  launcherPositionStyle.id = 'spclst-chat-teaser-position';
  launcherPositionStyle.textContent =
    '#gorgias-chat-container #chat-button {' +
      'bottom: 20px !important; transition: bottom 200ms ease;' +
    '}' +
    'body:has([class*="kl-teaser-"]) #gorgias-chat-container #chat-button {' +
      'bottom: 65px !important;' +
    '}' +
    '@media (max-width: 767px) {' +
      '#gorgias-chat-container #chat-button { bottom: 10px !important; }' +
      'body:has([class*="kl-teaser-"]) #gorgias-chat-container #chat-button {' +
        'bottom: 55px !important;' +
      '}' +
    '}' +
    // Hide only the launcher while navigation/search covers the storefront.
    // Include the drawer's closing animation so the bubble cannot flash over it.
    'body:has(.spclst-mega-mobile-drawer.spclst-open, .spclst-mega-mobile-drawer.spclst-closing,' +
      '.spclst-mega-mobile-search.spclst-open, .spclst-mega-desktop-search.spclst-active)' +
      ' #gorgias-chat-container #chat-button {' +
        'visibility: hidden !important; pointer-events: none !important;' +
    '}';
  document.head.appendChild(launcherPositionStyle);

  function addFrameStyle(frameId, styleId, css) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var frame = document.querySelector('#gorgias-chat-container #' + frameId);
      var frameDocument;

      try {
        frameDocument = frame && frame.contentWindow && frame.contentWindow.document;
      } catch (error) {
        frameDocument = null;
      }

      if (frameDocument && frameDocument.head && frameDocument.head.querySelector('[data-emotion]')) {
        if (!frameDocument.getElementById(styleId)) {
          var style = frameDocument.createElement('style');
          style.id = styleId;
          style.textContent = css;
          frameDocument.head.appendChild(style);
        }
        window.clearInterval(timer);
      } else if (attempts >= 200) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  var chatReady = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
      });

  chatReady.then(function () {
    function flattenButton() {
      addFrameStyle('chat-button', 'spclst-flat-chat-button',
        '#gorgias-chat-messenger-button {' +
          'background: none !important; box-shadow: none !important;' +
        '}' +
        '#gorgias-chat-messenger-button > div {' +
          'background: none !important; box-shadow: none !important;' +
        '}' +
        '#gorgias-chat-messenger-button::before {' +
          'content: ""; position: absolute; top: 50%; left: 50%;' +
          'width: 50%; height: 50%; transform: translate(-50%, -50%);' +
          'border-radius: 50%; background: #fff; z-index: 2;' +
        '}' +
        '#gorgias-chat-messenger-button svg {' +
          'width: 14px !important; height: 14px !important;' +
        '}' +
        '@media (max-width: 75px) {' +
          '#gorgias-chat-messenger-button svg {' +
            'width: 12px !important; height: 12px !important;' +
          '}' +
        '}'
      );
    }

    flattenButton();

    function flattenWindow() {
      addFrameStyle('chat-window', 'spclst-flat-chat-window',
        '#self-service-portal-container > div:nth-child(2) > div:first-child {' +
          'background: #fff !important;' +
        '}' +
        '#self-service-portal-container > div:nth-child(2) > div:first-child canvas {' +
          'display: none !important;' +
        '}' +
        '.widget-md > div:nth-child(2) {' +
          'background-image: none !important;' +
        '}'
      );
    }

    window.GorgiasChat.on('widget:opened', flattenWindow);
    window.GorgiasChat.on('widget:closed', flattenButton);
    if (window.GorgiasChat.isOpen()) flattenWindow();
  });
})();
